'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelTemplateApplicationSettings = exports.saveTemplateApplicationSettings = exports.changeTemplateApplicationSettingsProperty = exports.getTemplatesSettings = exports.setLogoAlignment = exports.LOGO_ALIGNMENT = exports.CANCEL_TEMPLATE_SETTINGS = exports.SAVE_TEMPLATESETTINGS_TYPES = exports.GET_TEMPLATES_SETTINGS_TYPES = exports.CHANGE_PROPERTY = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.validateTemplateSettings = validateTemplateSettings;
exports.fetchTemplatesSettingsSaga = fetchTemplatesSettingsSaga;
exports.saveTemplateApplicationSettingsSaga = saveTemplateApplicationSettingsSaga;
exports.watchGetTemplatesSettings = watchGetTemplatesSettings;
exports.watchSaveTemplateApplicationSettings = watchSaveTemplateApplicationSettings;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _fetchStatusTypes = require('constants/fetchStatusTypes');

var STATUS = _interopRequireWildcard(_fetchStatusTypes);

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _createFetchTypes = require('../../utils/createFetchTypes');

var _createFetchTypes2 = _interopRequireDefault(_createFetchTypes);

var _fetchEntitySagaAuth = require('../../utils/fetchEntitySagaAuth');

var _fetchEntitySagaAuth2 = _interopRequireDefault(_fetchEntitySagaAuth);

var _notifications = require('../notifications');

var _errorMsgs = require('constants/errorMsgs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchTemplatesSettingsSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(saveTemplateApplicationSettingsSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchGetTemplatesSettings),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSaveTemplateApplicationSettings);

var CHANGE_PROPERTY = exports.CHANGE_PROPERTY = 'tq-plus-admin/templatesSettings/CHANGE_PROPERTY';

var GET_TEMPLATES_SETTINGS_TYPES = exports.GET_TEMPLATES_SETTINGS_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/templates/GET_TEMPLATES_SETTINGS');

var SAVE_TEMPLATESETTINGS_TYPES = exports.SAVE_TEMPLATESETTINGS_TYPES = (0, _createFetchTypes2.default)('tq-plus-admin/templatesSettings/SAVE_TEMPLATESETTINGS_TYPES');

var CANCEL_TEMPLATE_SETTINGS = exports.CANCEL_TEMPLATE_SETTINGS = 'tq-plus-admin/templatesSettings/CANCEL_TEMPLATE_SETTINGS';

var LOGO_ALIGNMENT = exports.LOGO_ALIGNMENT = 'tq-plus-admin/configuration/LOGO_ALIGNMENT';

var initialState = {
  current: {},
  temp: {},
  error: null,
  logoAlignment: 'left',

  templatesSettingsStatus: STATUS.UNRETRIEVED
};

// reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOGO_ALIGNMENT:
      {
        return (0, _extends4.default)({}, state, {
          logoAlignment: action.payload
        });
      }

    case GET_TEMPLATES_SETTINGS_TYPES.REQUEST:
      return (0, _extends4.default)({}, state, { templatesSettingsStatus: STATUS.REQUESTING });
    case GET_TEMPLATES_SETTINGS_TYPES.SUCCESS:
      return (0, _extends4.default)({}, state, {
        temp: action.templatesSettings || {},
        current: action.templatesSettings || {},
        templatesSettingsStatus: STATUS.SUCCEEDED
      });
    case GET_TEMPLATES_SETTINGS_TYPES.FAILURE:
      return (0, _extends4.default)({}, state, { templatesSettingsStatus: STATUS.FAILED });
    case CHANGE_PROPERTY:
      return (0, _extends4.default)({}, state, {
        temp: (0, _extends4.default)({}, state.temp, (0, _defineProperty3.default)({}, action.field, action.value))
      });

    case SAVE_TEMPLATESETTINGS_TYPES.REQUEST:
      {
        return (0, _extends4.default)({}, state);
      }
    case SAVE_TEMPLATESETTINGS_TYPES.FAILURE:
      return (0, _extends4.default)({}, state, { error: action.error });
    case SAVE_TEMPLATESETTINGS_TYPES.SUCCESS:
      return (0, _extends4.default)({}, state, {
        current: state.temp
      });
    case CANCEL_TEMPLATE_SETTINGS:
      return (0, _extends4.default)({}, state, {
        temp: (0, _extends4.default)({}, state.current)
      });

    default:
      return state;
  }
}
// Actions ---------------------------------------------------------------------
var setLogoAlignment = exports.setLogoAlignment = function setLogoAlignment(alignment) {
  return {
    type: LOGO_ALIGNMENT,
    payload: alignment
  };
};

var getTemplatesSettings = exports.getTemplatesSettings = {
  base: function base(token) {
    return {
      type: GET_TEMPLATES_SETTINGS_TYPES.BASE,
      url: 'template-configuration/get-templates-settings',
      token: token
    };
  },
  request: function request() {
    return { type: GET_TEMPLATES_SETTINGS_TYPES.REQUEST };
  },
  success: function success(templatesSettings) {
    return { type: GET_TEMPLATES_SETTINGS_TYPES.SUCCESS, templatesSettings: templatesSettings };
  },
  failure: function failure(error) {
    return { type: GET_TEMPLATES_SETTINGS_TYPES.FAILURE, error: error };
  }
};

var changeTemplateApplicationSettingsProperty = exports.changeTemplateApplicationSettingsProperty = function changeTemplateApplicationSettingsProperty(field, value) {
  return {
    type: CHANGE_PROPERTY, field: field, value: value
  };
};

var saveTemplateApplicationSettings = exports.saveTemplateApplicationSettings = {
  base: function base(templatesSettings, templatesList, removed, defaultTemplateId, token) {
    return {
      type: SAVE_TEMPLATESETTINGS_TYPES.BASE,
      url: 'template-configuration/save-templates-settings',
      data: { templatesSettings: templatesSettings, templatesList: templatesList, removed: removed, defaultTemplateId: defaultTemplateId },
      token: token
    };
  },
  request: function request() {
    return { type: SAVE_TEMPLATESETTINGS_TYPES.REQUEST };
  },
  success: function success(templatesSettings) {
    return { type: SAVE_TEMPLATESETTINGS_TYPES.SUCCESS, templatesSettings: templatesSettings };
  },
  failure: function failure(error) {
    return { type: SAVE_TEMPLATESETTINGS_TYPES.FAILURE, error: error };
  }
};

var cancelTemplateApplicationSettings = exports.cancelTemplateApplicationSettings = function cancelTemplateApplicationSettings() {
  return { type: CANCEL_TEMPLATE_SETTINGS };
};

function validateTemplateSettings(data) {

  var tplMId = data.template.markingId;
  var tplName = data.template.name;
  var tplId = data.template.id;
  var templates = data.templates;
  var txtNotification = '';
  var validateResult = {
    msg: '',
    validated: false
  };
  var uniqId = true;
  var uniqName = true;

  (0, _keys2.default)(templates).map(function (key) {
    var obj = templates[key];
    if (tplId !== obj.id) {
      if (tplMId === obj.markingId) {
        uniqId = false;
      }
      if (tplName.toLowerCase() === obj.name.toLowerCase()) {
        uniqName = false;
      }
    }
  });

  if (tplMId && tplName && uniqName && uniqId) {
    validateResult.msg = '';
    validateResult.validated = true;
  } else {
    if (!tplMId) {
      txtNotification += ' Marking Id' + _errorMsgs.ERR_MANDATORY_FIELD;
    }
    if (!tplName) {
      txtNotification += ' Template Name' + _errorMsgs.ERR_MANDATORY_FIELD;
    }
    if (!uniqName) {
      txtNotification += 'Template Name' + _errorMsgs.ERR_REPEATED_FIELD;
    }
    if (!uniqId) {
      txtNotification += 'Marking Id' + _errorMsgs.ERR_REPEATED_FIELD;
    }
    validateResult.msg = txtNotification;
  }
  return validateResult;
}

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
function fetchTemplatesSettingsSaga(_ref) {
  var url = _ref.url,
      token = _ref.token;
  return _regenerator2.default.wrap(function fetchTemplatesSettingsSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(getTemplatesSettings, _api2.default.get, url, { token: token });
          });

        case 3:
          return _context.abrupt('return', _context.sent);

        case 6:
          _context.prev = 6;
          _context.t0 = _context['catch'](0);
          _context.next = 10;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error retrieving template settings',
            message: _context.t0.message
          }));

        case 10:

          console.error(_context.t0);

        case 11:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 6]]);
}

function saveTemplateApplicationSettingsSaga(_ref2) {
  var url = _ref2.url,
      data = _ref2.data,
      token = _ref2.token;
  var result;
  return _regenerator2.default.wrap(function saveTemplateApplicationSettingsSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySagaAuth2.default)(saveTemplateApplicationSettings, _api2.default.post, url, { data: data, token: token });
          });

        case 3:
          result = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)((0, _notifications.success)({
            title: 'Success',
            message: 'Templates Settings have been saved correctly'
          }));

        case 6:
          return _context2.abrupt('return', result);

        case 9:
          _context2.prev = 9;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 13;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error saving Templates Settings',
            message: _context2.t0.message
          }));

        case 13:

          // throw error;
          console.error(_context2.t0);
          return _context2.abrupt('return', _context2.t0);

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 9]]);
}

function watchGetTemplatesSettings() {
  return _regenerator2.default.wrap(function watchGetTemplatesSettings$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.delegateYield((0, _reduxSaga.takeLatest)(GET_TEMPLATES_SETTINGS_TYPES.BASE, fetchTemplatesSettingsSaga), 't0', 1);

        case 1:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function watchSaveTemplateApplicationSettings() {
  return _regenerator2.default.wrap(function watchSaveTemplateApplicationSettings$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _reduxSaga.takeLatest)(SAVE_TEMPLATESETTINGS_TYPES.BASE, saveTemplateApplicationSettingsSaga), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/templates/templatesSettings.js
// module id = 353
// module chunks = 0